import { observable, action, reaction, makeObservable } from 'mobx';
import { isSome } from 'core/utils';

class FilterParams {
	@observable pageNumber;
	@observable pageSize;
	@observable orderBy;
	@observable orderDirection;
	@observable embed;
	@observable search;
	@observable searchFields;
	@observable fields;

	constructor(pageSize) {
		makeObservable(this);
		this.reset(pageSize);

		reaction(
			() => this.search,
			search => {
				this.search = isSome(search) && search !== '' ? search : undefined;
			}
		);
	}

	@action
	reset = (pageSize = null) => {
		this.pageNumber = 1;
		this.pageSize = pageSize ? pageSize : 100;
		this.orderBy = null;
		this.orderDirection = null;
		this.embed = null;
		this.search = null;
		this.searchFields = null;
		this.fields = null;
	};
}

export default FilterParams;



// WEBPACK FOOTER //
// ./src/core/models/FilterParams.js